// extracted by mini-css-extract-plugin
export default {"popover":"popover____dYwJ","noticeButton":"noticeButton___OyIUZ","icon":"icon___Yveih","badge":"badge___tHdX0","tabs":"tabs___yB7Yv"};